import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import './Home.css'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Bookcards from '../../components/Bookscard/Bookcards'
import BannerImg from '../../components/Banner/Ebook.svg'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Home() {
  const [isVisible, setIsVisible] = useState(false)
  const [latestBooks, setLatestBooks] = useState([])
  const [selfHelpBooks, setSelfHelpBooks] = useState([])
  const [latestPosts, setLatestPosts] = useState([])
  const [loadingPosts, setLoadingPosts] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const getSummaryBooks = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/summary-books`)
      const booksData = response.data || []
      
      const sortedByDate = [...booksData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      setLatestBooks(sortedByDate.slice(0, 4))
      
      const selfHelp = booksData.filter(book => 
        book.categories && book.categories.some(cat => 
          cat.toLowerCase() === 'self-help' || 
          cat.toLowerCase() === 'self help' ||
          cat === 'Self-Help'
        )
      )
      setSelfHelpBooks(selfHelp.slice(0, 4))
    }
    catch (err) {
      console.error(err)
    }
  }

  // دریافت آخرین مقالات
  const getLatestPosts = async () => {
    setLoadingPosts(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/blog/posts`)
      const postsData = response.data.data || []
      setLatestPosts(postsData.slice(0, 3)) // فقط 3 مقاله آخر
    } catch (err) {
      console.error('Error fetching latest posts:', err)
    } finally {
      setLoadingPosts(false)
    }
  }

  useEffect(() => {
    getSummaryBooks()
    getLatestPosts()
  }, [])

  // Structured Data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "چکیده‌سرا",
    "alternateName": "ChekideSara",
    "description": "پلتفرم تخصصی خلاصه کتاب‌های انگلیسی با قابلیت ترجمه لحظه‌ای و سیستم هوشمند لایتنر برای تقویت دایره لغات",
    "url": "https://chekidesara.ir",
    "logo": "https://chekidesara.ir/logo.png",
    "sameAs": [
      "https://t.me/chekidesara",
      "https://instagram.com/chekidesara"
    ],
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://chekidesara.ir/summary-books?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }

  return (
    <>
      <Helmet>
        <html lang="fa" dir="rtl" />
        <title>چکیده‌سرا | یادگیری زبان انگلیسی با خلاصه کتاب‌های سطح‌بندی شده و سیستم لایتنر هوشمند</title>
        <meta name="description" content="بهترین روش یادگیری زبان انگلیسی: مطالعه خلاصه کتاب‌های سطح‌بندی شده A1 تا C2 + ترجمه لحظه‌ای کلمات + سیستم فلش‌کارت لایتنر برای تقویت دایره لغات. بدون نیاز به نصب نرم‌افزار." />
        <meta name="keywords" content="یادگیری زبان انگلیسی, خلاصه کتاب انگلیسی, سیستم لایتنر, تقویت دایره لغات, کتاب سطح‌بندی شده, آیلتس, تافل, ریدینگ انگلیسی, مقالات آموزشی" />
        <meta name="author" content="چکیده‌سرا" />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="revisit-after" content="1 days" />
        
        {/* Open Graph / Social Media */}
        <meta property="og:title" content="چکیده‌سرا | یادگیری زبان انگلیسی با خلاصه کتاب‌های سطح‌بندی شده" />
        <meta property="og:description" content="ترجمه لحظه‌ای کلمات + سیستم لایتنر هوشمند + کتاب‌های سطح‌بندی شده A1 تا C2 + مقالات آموزشی" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chekidesara.ir" />
        <meta property="og:image" content="https://chekidesara.ir/og-image.jpg" />
        <meta property="og:locale" content="fa_IR" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="چکیده‌سرا | یادگیری زبان انگلیسی" />
        <meta name="twitter:description" content="خلاصه کتاب‌های انگلیسی + ترجمه لحظه‌ای + سیستم لایتنر + مقالات آموزشی" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://chekidesara.ir" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <Navbar />

      {/* ========== HERO SECTION با کلمات کلیدی قوی ========== */}
      <header className="hero">
        <div className="hero-bg"></div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">✨ ویژه زبان‌آموزان آیلتس و تافل</div>
            <h1 className={`hero-title ${isVisible ? 'visible' : ''}`}>
              یادگیری زبان انگلیسی با
              <span className="hero-accent">خلاصه کتاب‌های سطح‌بندی شده</span>
            </h1>
            <p className={`hero-sub ${isVisible ? 'visible' : ''}`}>
              📚 <strong>ترجمه لحظه‌ای کلمات</strong> • 🧠 <strong>سیستم لایتنر هوشمند</strong> • 📖 <strong>مناسب همه سطوح</strong>
            </p>
            <div className="hero-buttons">
              <Link to="/summary-books" className="btn-outline">
                شروع مطالعه رایگان
                <span className="btn-arrow">→</span>
              </Link>

            </div>
            <div className="hero-stats">
              <span>✅ +۱۰۰ خلاصه کتاب</span>
              <span>✅ ۵ سطح زبانی</span>
              <span>✅ ترجمه آنی</span>
              <span>✅ مقالات آموزشی</span>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src={BannerImg} 
              alt="یادگیری زبان انگلیسی با خلاصه کتاب و سیستم لایتنر - چکیده‌سرا" 
              className="hero-img"
              loading="eager"
              width="650"
              height="500"
            />
          </div>
        </div>
      </header>

      {/* ========== INTRO SECTION - توضیح مزیت رقابتی ========== */}
      <section className="intro" aria-label="مزیت چکیده‌سرا">
        <div className="container">
          <div className="intro-line"></div>
          <h2 className="intro-title">چرا خواندن خلاصه کتاب در چکیده‌سرا مؤثرتر از روش‌های سنتی است؟</h2>
          <p className="intro-text">
            در <span className="intro-brand">چکیده‌سرا</span>، <strong>خلاصه کتاب‌های انگلیسی</strong> را همراه با 
            <strong> ترجمه لحظه‌ای کلمات</strong> و <strong>سیستم هوشمند لایتنر</strong> مطالعه می‌کنی.
            <br />
            بدون قطع تمرکز، بدون نصب نرم‌افزار، بدون اتلاف وقت برای جستجوی لغت در دیکشنری.
          </p>
          <div className="intro-line"></div>
        </div>
      </section>

      {/* ========== جدیدترین خلاصه کتاب‌ها ========== */}
      <section className="books-section" aria-label="جدیدترین خلاصه کتاب‌های انگلیسی">
        <div className="container">
          <div className="section-header-new">
            <h2>🆕 جدیدترین خلاصه‌کتاب‌های انگلیسی</h2>
            <Link to="/summary-books" className="view-all-link">مشاهده همه کتاب‌ها ←</Link>
          </div>
          {latestBooks.length > 0 ? (
            <div className="books-grid">
              {latestBooks.map((book) => (
                <Bookcards key={book._id} {...book} />
              ))}
            </div>
          ) : (
            <div className="loading">در حال بارگذاری...</div>
          )}
        </div>
      </section>

      {/* ========== منتخب توسعه فردی (Self Help) ========== */}
      <section className="books-section alternate" aria-label="بهترین کتاب‌های توسعه فردی انگلیسی">
        <div className="container">
          <div className="section-header-new">
            <h2>🌟 بهترین کتاب‌های توسعه فردی برای تقویت زبان</h2>
            <Link to="/summary-books" className="view-all-link">مشاهده همه ←</Link>
          </div>
          {selfHelpBooks.length > 0 ? (
            <div className="books-grid">
              {selfHelpBooks.map((book) => (
                <Bookcards key={book._id} {...book} />
              ))}
            </div>
          ) : (
            <div className="loading">در حال بارگذاری...</div>
          )}
        </div>
      </section>

      {/* ========== آخرین مقالات وبلاگ ========== */}
      <section className="blog-section" aria-label="آخرین مقالات آموزشی">
        <div className="container">
          <div className="section-header-new">
            <h2>📝 آخرین مقالات آموزشی</h2>
            <Link to="/blog" className="view-all-link">مشاهده همه مقالات ←</Link>
          </div>
          {loadingPosts ? (
            <div className="loading">در حال بارگذاری مقالات...</div>
          ) : latestPosts.length > 0 ? (
            <div className="blog-grid">
              {latestPosts.map((post) => (
                <article key={post._id} className="blog-card">
                  {post.image && (
                    <div className="blog-card-image">
                      <img 
                        src={post.image} 
                        alt={post.title}
                        loading="lazy"
                        width="350"
                        height="200"
                      />
                    </div>
                  )}
                  <div className="blog-card-content">
                    <div className="blog-meta">
                      <span>📅 {new Date(post.publishedAt).toLocaleDateString('fa-IR')}</span>
                      <span>⏱️ {post.readTime} دقیقه مطالعه</span>
                    </div>
                    <h3>
                      <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                    </h3>
                    <p>{post.excerpt}</p>
                    <Link to={`/blog/${post.slug}`} className="read-more-link">
                      ادامه مطلب ←
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="no-data">در حال حاضر مقاله‌ای وجود ندارد.</div>
          )}
        </div>
      </section>

      {/* ========== FEATURES - مزایای رقابتی ========== */}
      <section className="features" aria-label="مزایای چکیده‌سرا نسبت به روش‌های سنتی">
        <div className="container">
          <h2 className="section-title">چرا چکیده‌سرا برای یادگیری زبان انگلیسی انتخاب بهتری است؟</h2>
          <div className="features-grid">
            <article className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>ترجمه لحظه‌ای بدون قطع تمرکز</h3>
              <p>برخلاف دیکشنری‌های سنتی، فقط کافی است کلمه را انتخاب کنی. ترجمه در همان لحظه و در همان صفحه نمایش داده می‌شود.</p>
            </article>
            <article className="feature-card">
              <div className="feature-icon">🧠</div>
              <h3>سیستم لایتنر هوشمند برای ثبت لغات</h3>
              <p>لغاتی که ذخیره می‌کنی، طبق اصول علمی تکرار فاصله‌دار به تو یادآوری می‌شوند. دیگر نگران فراموشی نباش.</p>
            </article>
            <article className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>کتاب‌های سطح‌بندی شده از A1 تا C2</h3>
              <p>از مبتدی تا پیشرفته، خلاصه کتاب‌هایی متناسب با سطح زبانی خودت پیدا می‌کنی. هیچ کتابی بالاتر یا پایین‌تر از سطح تو نیست.</p>
            </article>
            <article className="feature-card">
              <div className="feature-icon">💸</div>
              <h3>بسیار مقرون‌به‌صرفه نسبت به کتاب اصلی</h3>
              <p>یک جلد کتاب انگلیسی ۳۰۰ صفحه‌ای حداقل ۲۰۰ هزار تومان قیمت دارد. اشتراک چکیده‌سرا از یک کتاب هم ارزان‌تر است.</p>
            </article>
          </div>
        </div>
      </section>

      {/* ========== TRUST SECTION ========== */}
      <section className="trust" aria-label="مخاطبان چکیده‌سرا">
        <div className="container">
          <div className="trust-inner">
            <h2>این روش برای چه کسانی مناسب است؟</h2>
            <p>
              <strong>📖 دانشجویان</strong> و <strong>داوطلبان آیلتس و تافل</strong> که می‌خواهند بدون صرف ماه‌ها زمان، ریدینگ خود را تقویت کنند.<br />
              <strong>👩‍🏫 مدرسان زبان</strong> که به دنبال منبعی غنی و استاندارد برای تدریس هستند.<br />
              <strong>💼 مدیران و متخصصان</strong> که وقت خواندن کتاب‌های ۳۰۰ صفحه‌ای را ندارند.<br />
              <strong>🧠 هر کسی</strong> که می‌خواهد دایره لغات انگلیسی خود را بدون خستگی و فراموشی افزایش دهد.
            </p>
          </div>
        </div>
      </section>

      {/* ========== CTA SECTION - Call to Action قوی ========== */}
      <section className="cta" aria-label="شروع یادگیری">
        <div className="container">
          <div className="cta-block">
            <blockquote>
              «در چکیده‌سرا، فقط خواننده نیستی.  
              با انتخاب متن، واژگان تو در <strong>سیستم لایتنر هوشمند</strong> ذخیره می‌شود و هرگز فراموش نمی‌کنی.»
            </blockquote>
            <div className="cta-buttons">
              <Link to="/summary-books" className="btn-primary-white">
                همین حالا اولین کتاب را شروع کن
              </Link>
              <Link to="/subscription" className="btn-outline-light">
                مشاهده طرح‌های اشتراک
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default Home